// import React, { useState, useEffect, useRef } from 'react';
// import DataTableLayout from '../../../../utility/table/DataTableLayout.jsx'
// import CommonComponent from "../../CommonComponent"
// import { ordersTableData } from '../../Common/Datatable';
// import { useOption } from '../../../../context/OptionContext';

// const Orders = () => {
//   const { tableId, ajaxUrl, columns, ajaxMethodType } = ordersTableData;
//   const { selectedOption } = useOption();

//   const headers = selectedOption?.id ? { 'marketplace-Id': selectedOption.id } : {};

//   return (
//     <>
//       <CommonComponent />
//       <section className="section dashboard py-2">
//         <DataTableLayout
//           tableId={tableId}
//           ajaxUrl={ajaxUrl}
//           columns={columns}
//           ajaxMethod={ajaxMethodType}
//           headers={headers}
//           dependency={selectedOption?.id}
//         />
//       </section>
//     </>
//   );
// }

// export default Orders;

import React from "react";
import CommonComponent from "../../CommonComponent";
import { ordersTableData } from "../../Common/Datatable";
import DataTableLayout from "../../../../utility/table/DataTableLayout.jsx";
import { useOption } from "../../../../context/OptionContext";

const Orders = () => {
  const { tableId, ajaxUrl, columns, ajaxMethodType } = ordersTableData;
  const { selectedOption } = useOption();

  const headers = selectedOption?.id
    ? { "marketplace-Id": selectedOption.id }
    : {};

  return (
    <>
      <CommonComponent />

      <section className="section dashboard py-2">
        <div className="row m-0">
          <div className="filter"></div>
          <div className="card-body h-auto">
            <DataTableLayout
              tableId={tableId}
              ajaxUrl={ajaxUrl}
              columns={columns}
              ajaxMethod={ajaxMethodType}
              headers={headers}
              dependency={selectedOption?.id}
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default Orders;
